export const API_KEY: string = "pk.eyJ1IjoicmVhbGl0eWdhbWVzIiwiYSI6ImNrd2V3ejJsdDA5MmsybnF2djF2Z2I0NWoifQ.XKFFjpeHqmI1QOv7nC3kDg";
export const MAP_STYLE: string = "mapbox://styles/realitygames/ckyhqe8n587dr14nuq457i645";

// Temporary kill switch for the 3D Mapbox globe. While false, MainMapComponent is
// never rendered, so its lazy chunk never loads and no requests go to Mapbox
// (styles/tiles) or the draco CDN. Flip back to true to re-enable the map.
export const MAP_ENABLED: boolean = false;